import { RangePicker, RangePickerRef } from '@components/ui';
import { CalendarSimpleOutlined, SearchOutlined } from '@icon';
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import { IDateRange } from 'types/life-id';

export const DEFAULT_DATE_RANGE = {
  from: null,
  to: null,
};

type TProps = {
  onSubmit: (range: IDateRange) => void;
};

function HistoryRangePicker(props: TProps) {
  const [currentRange, setCurrentRange] = useState<IDateRange>(DEFAULT_DATE_RANGE);
  const rageRef = React.useRef<RangePickerRef>(null);

  const haveValues = currentRange.from && currentRange.to;

  const handleSubmitClick = useCallback(() => {
    if (haveValues) {
      props.onSubmit(currentRange);
      rageRef.current?.blur();
    }
  }, [currentRange, haveValues]);

  const handleClearClick = useCallback(() => {
    setCurrentRange(DEFAULT_DATE_RANGE);
    props.onSubmit(DEFAULT_DATE_RANGE);
  }, []);

  useEffect(() => {
    return handleSubmitClick;
  }, []);

  return (
    <>
      <RangePicker
        ref={rageRef}
        variant="on-dark"
        value={
          currentRange.from && currentRange.to
            ? [moment(currentRange.from).toDate(), moment(currentRange.to).toDate()]
            : currentRange.from
            ? [moment(currentRange.from).toDate()]
            : []
        }
        outlined
        right={
          <RangePicker.Action
            Icon={SearchOutlined}
            variant={'on-dark'}
            onClick={handleSubmitClick}
          />
        }
        left={<RangePicker.Icon Icon={CalendarSimpleOutlined} variant={'on-dark'} />}
        onChange={(dates) => {
          if (dates.length === 0) {
            handleClearClick();
          } else {
            setCurrentRange({
              // @ts-ignore
              from: dates[0] ? moment(dates[0]).startOf('day').toISOString() : currentRange.from,
              // @ts-ignore
              to: dates[1] ? moment(dates[1]).endOf('day').toISOString() : currentRange.to,
            });
          }
        }}
      />
    </>
  );
}

export default React.memo(HistoryRangePicker);
